<script>
export default {
    props: ['color', 'type'],
    name: "loading",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="loading" :class="[color, type]"></div>
</template>

<style scoped lang="scss">
.loading{
    margin: .5rem auto;
    width: .4rem;
    height: .4rem;
    border: 1px solid #000;
    border-radius: 50%;
    border-top-color: transparent !important;
    animation: circle infinite 0.75s linear;
    &.white{
        border-color: #fff;
    }
    &.smail{
        width: .2rem;
        height: .2rem;
        margin: 0 auto;
        @media only screen and (max-width: 750px) {
            width: .3rem;
            height: .3rem;
        }
    }
}
// 转转转动画
@keyframes circle {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>